<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="hypersoft-warenkorp.svg"></div>
    </div>
    <div @plopInOut class="header-content">
      <div class="checkmark-container">
        <div class="inline-icon onlile-account-checkmark" inlineSVG="hypersoft-check-voll.svg"></div>
      </div>
      <div class="info">
        <h2 langkey="phRemoteOrder_ContinueOrder_Label"></h2>
      </div>
    </div>
    <div class="item">
      <div class="item-content">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="modalData.image" alt="" />
            </div>
          </div>
        </div>
        <div class="item-info">
          <div class="item-info-wrapper">
            <div class="item-detail">
              <h2 class="title">
                {{modalData.label}}
              </h2>
            </div>
            <div class="item-price-detail">
              <div class="item-count">{{modalData.count}}</div>
              <div class="item-amount">{{(setItemPrice())}}</div>
            </div>
          </div>
          <ng-container *ngIf="modalData.extras && modalData.extras.length>0">
            <div class="extra-item-wrapper">
              <div [id]="'prucudtExtraContainer---'" class="extra-item-container active">
                <p>{{setExtraString()}}</p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngIf="modalData.canComment ">
      <div class="comment-area">
        <div [id]="'comment'+ modalData.id"
          [ngClass]="['item-comment', commentVisibleInitilize && showComment()?'show-comment':'']">
          <textarea class="ya-caption" minlength="1" maxlength="200"
            (blur)="closeEmptyTextArea($event.currentTarget.value, modalData.id)" tabindex="-1" id="item1"
            [(ngModel)]="modalData.comment"></textarea>
        </div>
        <div [id]="'commentLink'+modalData.id"
          [ngClass]="['item-comment-link', commentVisibleInitilize && showComment() ?'hide-anmerkung':'']">
          <a (click)="toggleCommentArea(modalData.id)">
            <span class="ya-caption" langkey="phWebshop_Item_Show_Comment"></span>
          </a>
        </div>
      </div>
    </ng-container>
    <div class="selection-state">
      <div class="info">
        <span langkey="phRemoteOrder_ContinueOrder_State_Info"></span>
      </div>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="continue()">
              <span langkey="phRemoteOrder_ContinueOrder_Btn_Continue"></span>
            </button>
          </div>
          <div class="ya-button-container">
            <button mat-stroked-button (click)="navigateToBasket(userId,true)">
              <span langkey="phRemoteOrder_ContinueOrder_Btn_Cart"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>